<template>
	<div class="container">
		
		<div v-for="(item, index) in items" :key="index" class="page">
			<div class="row justify-content-between item">
				<div class="col-md-5 col-xl-5" :class="index % 2 === 0 ? '' : 'order-md-2'"  style="margin-top: 120px;">
					<h2 class="info-title">{{item.title}}</h2>
					<div class="info-tag"></div>
					<p class="info-desc">{{item.desc}}</p>
				</div>
				<div class="col-md-7 col-xl-7">
					<img draggable="false" :src="item.imgUrl" alt="" />
				</div>
			</div>
		</div>
		

	</div>
</template>

<script>
	export default {
		props: {
			items: Array
		},
		data() {
			return {
			}
		}
	}
</script>

<style scoped lang="scss">
	.page {
		min-height: 80vh;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.item {
		padding-top: 40px;
		padding-bottom: 40px;
	}
	.info-tag {
		width: 56px;
		height: 7px;
		background: #FF3147;
		border-radius: 4px;
		margin-bottom: 20px;
	}
	.info-title {
		font-size: calc(1em + 1vw);
		line-height: calc(2.2em + 1vw);
		color: #333333;
		font-weight: 600;
	}
	.info-desc {
		font-size: calc(0.7em + 0.6vw);
		color: #999999;
		line-height: calc(1.2em + 0.8vw);
		font-weight: 400;
		letter-spacing: 1px;
	}
</style>
